// extracted by mini-css-extract-plugin
export var displayNone = "_k7-6";
export var imgContainer = "_k7-2";
export var overflowHidden = "_k7-3";
export var productInfoCardButtonContainer = "_k7-5";
export var productTitleText = "_k7-4";
export var rightArrow = "_k7-1";
export var rightArrowContainer = "_k7-0";